export default __webpack_public_path__ + "static/media/TVinsure-Covid-Card-Dhp.f6ec307c.jpg";